export const callHeaders = [ "Close", "LTP"];

export const putHeaders = ["LTP", "Close"];

export const callGreekHeaders = [
  "Volume",
  "LTP",
  "Change",
  "Bid",
  "Ask",
  "Delta",
  "Gamma",
  "Theta",
  "Vega",
];

export const putGreekHeaders = [
  "Bid",
  "Ask",
  "Change",
  "LTP",
  "Volume",
  "OI",
  "Delta",
  "Gamma",
  "Theta",
  "Vega",
];
